<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-main" v-loading="loading" element-loading-text="拼命加载中">
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
        <el-form :inline="true" :model="filters" :rules="filtersRules" ref="filters">
          <el-form-item>
            <el-button type="success" @click="listExcel" :loading="excelLoading">积分信息导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-col>
  </el-row>
</template>

<script>
import API from "../../../api/frbasicapi/member";
export default {
  data() {
    return {
      excelLoading: false,
    };
  },
  methods: {
    //序号
    indexMethod(index) {
      return (index + 1) + (this.page - 1) * (this.limit)
    },
    formatmobile: function (row, column) {
      return row.mobile.substring(0, 3) + "****" + row.mobile.substring(7, 11);
    },

    //会员列表导出
    listExcel() {
      // 调用api接口
      let that = this;
      API.exportAllList().then((res) => {
        that.excelLoading = true;
        if (res) {
          const content = res;
          //console.log(res.headers['filename']);
          const blob = new Blob([content]);
          if ("download" in document.createElement("a")) {
            const link = document.createElement("a");
            // 文件名
            link.download = "会员积分信息Excel.xlsx";
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(link.href);
            document.body.removeChild(link);
            that.excelLoading = false;
          } else {
            navigator.msSaveBlob(blob, fileName);
          }
        }
      });
    },
  }
};
</script>
<style scoped>
::v-deep .el-radio {
  display: block;
  margin: 10px 0;
}
</style>
<style scoped>
::v-deep .el-radio__label {
  color: red;
  margin-right: 10px
}

::v-deep .el-radio__input.is-checked+.el-radio__label {
  color: red !important;
}

::v-deep .el-radio__input.is-checked .el-radio__inner {
  background: red !important;
  border-color: red !important;
}
</style>
